import customizeLookSelection from 'html/cyop/customize-look-selection.html';
import App from 'app/app.js';
import 'app/directive/LtCustomizeLookSelectionCtrl.js';

function LtCustomizeLookSelectionDirective() {
  return {
    restrict: 'E',
    scope: {
      onInit: '&',
      goToPreviousPage: '&',
      onSelectedLook: '&',
      selectedOrderLineDetail: '=',
      orderLine: '=',
      editableOrderLine: '=',
      favouriteLooks: '=',
      selectedSheetIndex: '='
    },
    template: customizeLookSelection,
    controller: 'LtCustomizeLookSelectionCtrl',
    controllerAs: 'customizeLookSelection'
  };
}

App.directive('ltCustomizeLookSelection', [LtCustomizeLookSelectionDirective]);
